export enum UOM {
  EACH = 'portion',
  POUND = 'pound',
  OUNCE = 'ounce',
  GRAM = 'grams',
  GALLON = 'gallon',
  QUART = 'quart',
  PINT = 'pint',
  CUP = 'cup',
  FLUID_OUNCE = 'liquidOunce',
  EACH_PORTION = 'portion',
  TSP = 'teaspoon',
  TBSP = 'tablespoon',
}

export const getUOMTranslation = (uom: UOM): string => {
  switch (uom) {
    case UOM.EACH:
      return 'i18n.menuProfitPro.uomOptions.each';
    case UOM.POUND:
      return 'i18n.menuProfitPro.uomOptions.pound';
    case UOM.OUNCE:
      return 'i18n.menuProfitPro.uomOptions.ounce';
    case UOM.GRAM:
      return 'i18n.menuProfitPro.uomOptions.gram';
    case UOM.GALLON:
      return 'i18n.menuProfitPro.uomOptions.gallon';
    case UOM.QUART:
      return 'i18n.menuProfitPro.uomOptions.quart';
    case UOM.PINT:
      return 'i18n.menuProfitPro.uomOptions.pint';
    case UOM.CUP:
      return 'i18n.menuProfitPro.uomOptions.cup';
    case UOM.FLUID_OUNCE:
      return 'i18n.menuProfitPro.uomOptions.liquid';
    case UOM.EACH_PORTION:
      return 'i18n.menuProfitPro.uomOptions.eachPortion';
    case UOM.TSP:
      return 'i18n.menuProfitPro.uomOptions.tsp';
    case UOM.TBSP:
      return 'i18n.menuProfitPro.uomOptions.tbsp';
    default:
      return '';
  }
};
